import "../media/css/AddToHomeScreen.css";
import React from 'react';
import {Button, ButtonGroup} from "reactstrap";

const disposeDialog = (evt) => {
	evt.target.closest('.AddToHomeScreen').classList.remove("active");
	delete window.deferredAthsPrompt;
	window.sessionStorage.setItem('AthsRefused','1');
};

const init = (uid) => {
	const tgt = window.document.getElementById(uid);
	tgt.classList.add('active');
	tgt.querySelector('button.add').addEventListener('click', (e) => {
		tgt.classList.remove("active");
		window.deferredAthsPrompt.prompt();
		window.deferredAthsPrompt.userChoice.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					window.localStorage.setItem('AthsAccepted','1');
					console.log('User accepted the A2HS prompt');
				} else {
					window.sessionStorage.setItem('AthsRefused','1');
					console.log('User dismissed the A2HS prompt');
				}
				delete window.deferredAthsPrompt;
			});
	});
};

class AddToHomeScreen extends React.Component {
	constructor(props) {
		super(props);
		this.uid = "AddToHomeScreen-"+window.glob.generateUid();
	}
	componentDidMount() {
		if ( window.deferredAthsPrompt ) {
			init( this.uid);
		} else {
			window.glob.trigger('deferredAthsPrompt', () => { init( this.uid) }, this.uid);
		}
	}
	componentWillUnmount() {
		window.glob.unregister('deferredAthsPrompt', this.uid);
	}
	render() {
		return (
			<div className={"AddToHomeScreen"} id={this.uid}>
				<div className={"titlebar"}>
					<span className={"title"}>Aggiungi alla Home</span>
					<span className={"icon"}>ⓘ️</span>
					<span className={"closer"} onClick={disposeDialog}>✕</span>
				</div>
				<p>Questa web application può essere installata direttamente come App nella Home del tuo dispositivo.</p>
				<ButtonGroup>
					<Button className={"rm"} onClick={disposeDialog} color={"warning"}>
						✕ Annulla
					</Button>
					<Button className={"add"} color={"primary"}>
						✚ Aggiungi alla Home
					</Button>
				</ButtonGroup>
			</div>
		);
	}
}

export default AddToHomeScreen;